var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('a',{attrs:{"href":_vm.file_path + _vm.result,"download":""}},[_vm._v("Sample Image "+_vm._s(_vm.fileindex + 1))])]),_c('hr'),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }